<div class="flex-row">
    <div
        *ngFor="let header of headerOptions"
        class="mt-table-header normal-thickness col"
        [ngStyle]="{
            cursor: header.isSortable ? 'pointer' : 'inherit',
            'flex-grow': header.customLargeColumnConfig?.flexGrow
                ? header.customLargeColumnConfig?.flexGrow
                : header.isLargeColumn
                ? '3'
                : '1',
            padding: header.customLargeColumnConfig?.customPadding
                ? header.customLargeColumnConfig?.customPadding
                : '0px 15px'
        }"
        (click)="
            header.isSortable || header.sortBy
                ? sortByKey(header.value, header.sortBy)
                : null
        "
        [ngClass]="{
            'display-none': header.isExcludeColumn,
            'thin-thickness': thickness === rowThicknessEnum.Thin
        }"
    >
        <!-- IF HAS YOU NEED PUT A TOOLTIP AT LEFT SITE OF A HEADERS -->
        <ng-container *ngIf="header.tooltip">
            <label
                class="flex float-left"
                [ngStyle]="{
                    'margin-top': header.tooltip.marginTop,
                    'margin-right': header.tooltip.marginRight
                }"
            >
                <img
                    appImageSelector
                    alt="mt-image"
                    imageKey="info"
                    imageType="icon"
                    placement="top"
                    [ngbTooltip]="header.tooltip.text"
                    class="tooltip-info"
                />
                <span class="required-symbol"></span>
            </label>
        </ng-container>

        <ng-container *ngIf="header.isTranslatable; else elseTemplate">
            {{ header.visibleName.toLowerCase() | lang }}
        </ng-container>
        <ng-template #elseTemplate>
            {{ header.visibleName.toUpperCase() }}
        </ng-template>

        <ng-container *ngIf="header.isSortable">
            <img
                [ngStyle]="showSortImage(header.value, 'asc')"
                appImageSelector
                class="sort-asc"
                imageType="icon"
                imageKey="sort-table-asc"
            />

            <img
                [ngStyle]="showSortImage(header.value, 'desc')"
                appImageSelector
                class="sort-desc"
                imageType="icon"
                imageKey="sort-table-desc"
            />
        </ng-container>
    </div>
</div>
